import { fetchApi } from './fetchApi'

export default async function getFilesSFTP(qualifier) {
    try {
        const files = (await fetchApi('GET', `/services/plugin-upload/get/upload-s3/${qualifier}`)) as {
            data: string[]
        }
        if (files.data && files.data.length > 0) {
            const infoFiles = await Promise.all(
                files.data.map(async uuid => {
                    const infoFile = await fetchApi(
                        'GET',
                        `/services/plugin-upload/info/upload-s3/${qualifier}/${uuid}`
                    )
                    if (infoFile?.data) {
                        return infoFile?.data
                    }
                })
            )

            return infoFiles.filter(file => !!file)
        }

        return []
    } catch (e) {
        return []
    }
}

export async function listFilesSFTP(qualifier): Promise<string[]> {
    try {
        const files = (await fetchApi('GET', `/services/plugin-upload/get/upload-s3/${qualifier}`)) as {
            data: string[]
        }
        // console.log(files)
        return files.data
        // return files.data
    } catch (e) {
        return []
    }
}

export async function getSelectedFilesSFTP(qualifier: string, files: string[]): Promise<any[]> {
    try {
        const infoFiles = await Promise.all(
            files.map(async uuid => {
                const infoFile = await fetchApi('GET', `/services/plugin-upload/info/upload-s3/${qualifier}/${uuid}`)
                if (infoFile?.data) {
                    return infoFile?.data
                }
            })
        )
        return infoFiles
    } catch (e) {
        return []
    }
}